<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-4 mb-2">
              Aqui você pode cadastrar novos benefícios de aceleração, que
              ficarão visíveis as startups do portal em uma página de
              divulgação. Para tal, preencha as informações abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-9 col-lg-12">
          <div class="card shadow mb-3">
            <div class="card-header bg-transparent">
              <h3 class="mb-0">
                <i class="fas fa-building mr-2"></i>
                Cadastrar parceria
              </h3>
            </div>
            <div class="card-body vld-parent" ref="partner_controller">
              <div class="row ml-1">
                <h6 class="heading-small text-muted mb-4">
                  Informações básicas
                </h6>
              </div>
              <div class="row ml-lg-2">
                <div class="col-12">
                  <base-input label="Status da parceria">
                    <br />
                    <base-radio
                      name="public"
                      class="mb-3"
                      v-model="model.status"
                      :inline="true"
                    >
                      Visível
                    </base-radio>
                    <base-radio
                      name="hidden"
                      class="mb-3"
                      v-model="model.status"
                      :inline="true"
                    >
                      Oculto
                    </base-radio>
                  </base-input>
                </div>
                <div class="col-lg-6">
                  <base-input
                    label="Nome da parceria"
                    v-model.trim="model.name"
                    placeholder="Digite o nome"
                  />
                </div>
                <div class="col-lg-6">
                  <base-input
                    label="Categoria"
                    v-model.trim="model.category"
                    placeholder="Qual a categoria do benefício?"
                  />
                </div>
              </div>
              <hr class="mt-2 mb-4" />
              <div class="row ml-1">
                <h6 class="heading-small text-muted mb-4">
                  Informações complementares (opcional)
                </h6>
              </div>
              <div class="row ml-lg-2">
                <div class="col-lg-12">
                  <label class="form-control-label">Link externo</label>
                  <base-input
                    placeholder="Digite o link"
                    addon-left-icon="fas fa-external-link-alt"
                    v-model.trim="model.link"
                  >
                  </base-input>
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label"> Benefícios </label>
                  <div class="np-container-edditable">
                    <quill-editor
                      v-model="model.benefit"
                      :options="editorEdittable"
                    >
                    </quill-editor>
                  </div>
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label"> Instruções </label>
                  <div class="np-container-edditable">
                    <quill-editor
                      v-model="model.benefit"
                      :options="editorEdittable"
                    >
                    </quill-editor>
                  </div>
                </div>
                <div class="col-lg-12">
                  <hr class="my-4" />
                  <label class="form-control-label d-block"
                    >Imagem de destaque
                    <i
                      class="fas fa-info-circle mr-1 ml-2"
                      title="
                        'A imagem deve possuir tamanho máximo de 2MB e, preferencialmente, ser do formato <b>PNG</b> ou <b>JPG</b> com dimensão de <b>500x500 pixels</b>.'
                      "
                  /></label>
                  <file-select
                    v-model="image"
                    title="Selecione a imagem"
                    accept="image/*"
                    :mbSize="2"
                    type="warning"
                  ></file-select>
                </div>
                <div class="col-lg-12">
                  <hr class="my-4" />
                </div>
              </div>
              <div class="row mt-4" v-if="error">
                <div class="col-lg-12 text-center">
                  <base-alert type="danger">{{ error }}</base-alert>
                </div>
              </div>
              <div class="row mt-4 text-right">
                <div class="col-12">
                  <span
                    :title="
                      isValidModel
                        ? 'Clique para salvar'
                        : 'Preencha todas as informações obrigatórias antes de continuar'
                    "
                  >
                    <base-button
                      type="primary"
                      :custom="true"
                      @click="handleSubmit()"
                      :disabled="!isValidModel"
                      >Cadastrar parceria</base-button
                    >
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

import api from "@/services/api.js";

export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      model: {
        status: "public",
        name: "",
        category: "",
        benefit: "",
        instructions: "",
        link: "",
      },
      image: null,
      requiredFields: ["name", "category", "status"],
      error: "",
      editorEdittable: {
        placeholder:
          "Escreva aqui... (lembre-se, se necessário, você pode linkar arquivos pelo editor)",
      },
    };
  },
  methods: {
    async handleSubmit() {
      this.error = "";
      const loader = this.$loading.show({
        container: this.$refs.partner_controller,
        width: 90,
        height: 90,
      });
      try {
        const config = {
          headers: {
            "content-type": "multipart/form-data",
          },
        };
        const data = new FormData();
        if (this.image) {
          data.append("image", this.image, this.image.name);
        }
        data.append("model", JSON.stringify(this.model));
        await api.post("/adm/partners", data, config);
        this.$toasted.show("Parceria cadastrada com sucesso");
        this.$router.push("/admin/beneficios-aceleradas");
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao cadastrar a parceria");
        this.error =
          "Ocorreu um erro ao cadastrar a parceria. Por favor, verifique os campos e tente novamente.";
      } finally {
        loader.hide();
      }
    },
  },
  computed: {
    isValidModel() {
      const data = this.model;
      for (const key of this.requiredFields) {
        if (!data[key]) return false;
      }
      return true;
    },
  },
};
</script>
<style>
p > strong {
  font-weight: bold !important;
}
.np-container-edditable .quill-editor .ql-container,
.np-container-edditable .quill-editor .ql-container .ql-editor {
  height: 6rem;
  width: 100%;
}
</style>
